import type { SVGProps } from 'react'
const SvgSyTicket = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M13.85 3.5a.75.75 0 0 0-.75.75v2.42a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.75m0 13.51a.75.75 0 0 0-.75.75v2.023a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V17.76a.75.75 0 0 0-.75-.75m0-8.256a.75.75 0 0 0-.75.75v4.82a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-4.82a.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M5.299 3.25c-2.221 0-4.047 1.798-4.047 4.008L1.25 9.934a.75.75 0 0 0 .75.752c.843 0 1.426.533 1.426 1.316S2.808 13.4 2 13.4a.75.75 0 0 0-.75.75v2.592c0 2.21 1.827 4.008 4.049 4.008H18.7c2.222 0 4.049-1.798 4.049-4.008V14.15a.75.75 0 0 0-.75-.75c-.808 0-1.426-.615-1.426-1.398S21.192 10.6 22 10.6a.75.75 0 0 0 .75-.75l-.002-2.592c0-2.21-1.826-4.008-4.047-4.008zm0 1.5H18.7c1.421 0 2.547 1.119 2.547 2.508l.002 2.15c-1.2.36-2.176 1.286-2.176 2.594s.975 2.23 2.176 2.59v2.15c0 1.39-1.127 2.508-2.549 2.508H5.3c-1.422 0-2.549-1.118-2.549-2.508v-2.15c1.2-.36 2.176-1.282 2.176-2.59 0-1.306-.988-2.18-2.176-2.522l.002-2.222c0-1.39 1.126-2.508 2.547-2.508"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyTicket
